import { render, staticRenderFns } from "./RunningChart.vue?vue&type=template&id=4ba7e1f8&"
import script from "./RunningChart.vue?vue&type=script&lang=js&"
export * from "./RunningChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports